/**
 * Payouts cash Reducer
 */

import { Actions } from "containers/PayoutsCash/store/Actions";
import { Reducer } from "redux";
import { getPayoutsCashFormTranslations } from "root/shared/MultiLanguage";
import { IInputProps } from "root/store/CajitaStore";
import { IPayoutsCashActionCreator } from "types/payouts_cash_action_creator";
import { IPayoutsCashFormProps } from "types/payouts_cash_form_props";

const nameInputClasses: string[] = ["input"];
const classContainerNameInput: string = "inputContainer name-input";

const initialState: IPayoutsCashFormProps = {
  isCashOutAvailable: true,
  isValid: false,
  totalAmount: 0,
  token: "",
  nameInput: {
    container: "payouts_cash",
    value: "",
    classContainer: classContainerNameInput,
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^[ A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "nameInput",
      type: "text",
    },
  },
  lastNameInput: {
    container: "payouts_cash",
    value: "",
    classContainer: classContainerNameInput,
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^[ A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "lastNameInput",
      type: "text",
    },
  },
  identificationInput: {
    container: "payouts_cash",
    value: "",
    classContainer: "inputContainer id-input",
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^\d*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "identificationInput",
      type: "text",
    },
  },
  email: {
    container: "payouts_cash",
    value: "",
    classContainer: "inputContainer email-input",
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^[a-zA-Z0-9._!#$%&'*+-/=?^`{|}~@]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: false,
      maxLength: 100,
      isEmail: {
        email: true,
      },
    },
    attributes: {
      id: "email",
      type: "text",
    },
  },
  description: {
    container: "payouts_cash",
    value: "",
    classContainer: "inputContainer description-input",
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^[ A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: false,
      maxLength: 100,
    },
    attributes: {
      id: "description",
      type: "text",
    },
  },
  currency: "CLP",
  translation: getPayoutsCashFormTranslations(),
};

const PayoutsCashReducer: Reducer<IPayoutsCashFormProps> = (
  state: IPayoutsCashFormProps = initialState,
  action: IPayoutsCashActionCreator
): IPayoutsCashFormProps => {
  let input: IInputProps;

  switch (action.type) {
    case Actions.UPDATE_PAYOUTS_CASH_INPUT:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: input,
      };
    case Actions.SET_PAYOUTS_CASH_INPUT_DIRTY:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: {
          ...state[input.attributes.id],
          dirty: true,
        },
      };
    case Actions.SWITCH_PAYOUTS_CASH_VALIDITY:
      return {
        ...state,
        isValid: !state.isValid,
      };
    case Actions.SET_PAYOUTS_CASH_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    case Actions.DISABLE_PAYOUTS_CASH_FORM:
      return {
        ...state,
        isCashOutAvailable: false,
      };
    case Actions.ENABLE_PAYOUTS_CASH_FORM:
      return {
        ...state,
        isCashOutAvailable: true,
      };
    case Actions.UPDATE_DOCUMENT_TYPE_NUMBER:
      return {
        ...state,
        documentType: action.token,
      };
    default:
      return state;
  }
};

export { PayoutsCashReducer };



// WEBPACK FOOTER //
// ./src/containers/PayoutsCash/store/Reducer.tsx